// "+ List" on a search result: add one athlete to one of the viewer's own lists (the unified Lists
// feature, /reports). Lists save their whole roster on every change, so this reads the list, then
// writes it back with the athlete first, the same shape useListEditor.addMember persists.
import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const cfg = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export default function AddToListMenu({ athlete, label = '+ List' }) {
  const { API_URL } = useAuth();
  const [open, setOpen] = useState(false);
  const [lists, setLists] = useState(null);   // null = not loaded
  const [error, setError] = useState('');
  const [done, setDone] = useState('');       // title of the list the athlete was added to

  const toggle = async (e) => {
    e.stopPropagation();
    const next = !open;
    setOpen(next); setError(''); setDone('');
    if (next && lists === null) {
      try {
        const res = await axios.get(`${API_URL}/reports/index`, cfg());
        setLists(res.data.mine || []);
      } catch (err) {
        setError(err.response?.data?.detail || 'Could not load your lists.');
        setLists([]);
      }
    }
  };

  const add = async (e, list) => {
    e.stopPropagation();
    setError('');
    try {
      const got = await axios.get(`${API_URL}/reports/${list.id}`, cfg());
      const ids = (got.data.members || []).map((m) => m.user_id);
      if (ids.includes(athlete.user_id)) { setDone(`Already on ${list.title}`); return; }
      await axios.put(`${API_URL}/reports/${list.id}`,
        { title: got.data.title, sport: got.data.sport, athlete_user_ids: [athlete.user_id, ...ids] }, cfg());
      setDone(`Added to ${list.title}`);
    } catch (err) {
      setError(err.response?.data?.detail || 'Could not add to that list.');
    }
  };

  return (
    <span className="srch-addlist" onClick={(e) => e.stopPropagation()}>
      <button type="button" className="srch-link" aria-haspopup="menu" aria-expanded={open}
        aria-label={`${label} ${athlete.name || ''}`.trim()} onClick={toggle}>{label}</button>
      {open && (
        <div className="srch-menu" role="menu">
          {done && <div className="srch-menu__note" role="status">{done}</div>}
          {error && <div className="srch-menu__note srch-menu__note--err" role="alert">{error}</div>}
          {lists === null && <div className="srch-menu__note">Loading…</div>}
          {lists && lists.length === 0 && !error && <div className="srch-menu__note">No lists yet. Create one on the Lists page.</div>}
          {lists && lists.map((l) => (
            <button key={l.id} type="button" role="menuitem" className="srch-menu__item" onClick={(e) => add(e, l)}>{l.title}</button>
          ))}
        </div>
      )}
    </span>
  );
}
